// src/redux/actions/salesActions.js
import { 
    FETCH_MANAGER_ANALYTIC_REQUEST, 
    FETCH_MANAGER_ANALYTIC_SUCCESS, 
    FETCH_MANAGER_ANALYTIC_FAILURE 
} from '../../../../../Constants/actionTypes';
import { fetchMangerAnalytics } from '../../../../../Constants/apiService'

// Fetch Sales Request Action
export const fetchManAnalyticsRequest = () => ({
    type: FETCH_MANAGER_ANALYTIC_REQUEST,
});

// Fetch Sales Success Action
export const fetchManAnalyticsSuccess = (filter, salesData) => ({
    type: FETCH_MANAGER_ANALYTIC_SUCCESS,
    payload: { filter, data: salesData }, // Include the filter with the data
});

// Fetch Sales Failure Action
export const fetchManAnalyticsFailure = (error) => ({
    type: FETCH_MANAGER_ANALYTIC_FAILURE,
    payload: error,
});

// Thunk Action Creator for Fetching Sales
export const fetchManAnalyticsFuc = (filter) => {
    return async (dispatch, getState) => {
        dispatch(fetchManAnalyticsRequest());

        const state = getState();
        const accessToken = state.auth.accessToken; 
        console.log('Fetching data for:', filter);

        try {
            const data = await fetchMangerAnalytics(accessToken, filter);
            console.log(`Data fetched for ${filter}:`, data);
            dispatch(fetchManAnalyticsSuccess(filter, data)); // Pass filter with data
        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch(fetchManAnalyticsFailure(errorMessage));
        }
    };
};

